import Close from './popover-close.svelte'
import Content from './popover-content.svelte'
import Description from './popover-description.svelte'
import Header from './popover-header.svelte'
import Portal from './popover-portal.svelte'
import Title from './popover-title.svelte'
import Trigger from './popover-trigger.svelte'
import Root from './popover.svelte'

export {
	Root,
	Content,
	Description,
	Header,
	Title,
	Trigger,
	Close,
	Portal,
	//
	Root as Popover,
	Content as PopoverContent,
	Description as PopoverDescription,
	Header as PopoverHeader,
	Title as PopoverTitle,
	Trigger as PopoverTrigger,
	Close as PopoverClose,
	Portal as PopoverPortal,
}
